/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpsertBusinessMemorySettingsRequestBody = {
  /**
   * Maximum business-memory extraction evaluations reserved across the organization each UTC day. 0 disables extraction.
   */
  businessMemoryDailyCap: number;
  /**
   * Whether completed sessions are mined for business memories.
   */
  businessMemoryEnabled: boolean;
  /**
   * Organization whose settings to replace.
   */
  organizationId: string;
};

/** @internal */
export type UpsertBusinessMemorySettingsRequestBody$Outbound = {
  business_memory_daily_cap: number;
  business_memory_enabled: boolean;
  organization_id: string;
};

/** @internal */
export const UpsertBusinessMemorySettingsRequestBody$outboundSchema:
  z.ZodMiniType<
    UpsertBusinessMemorySettingsRequestBody$Outbound,
    UpsertBusinessMemorySettingsRequestBody
  > = z.pipe(
    z.object({
      businessMemoryDailyCap: z.int(),
      businessMemoryEnabled: z.boolean(),
      organizationId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        businessMemoryDailyCap: "business_memory_daily_cap",
        businessMemoryEnabled: "business_memory_enabled",
        organizationId: "organization_id",
      });
    }),
  );

export function upsertBusinessMemorySettingsRequestBodyToJSON(
  upsertBusinessMemorySettingsRequestBody:
    UpsertBusinessMemorySettingsRequestBody,
): string {
  return JSON.stringify(
    UpsertBusinessMemorySettingsRequestBody$outboundSchema.parse(
      upsertBusinessMemorySettingsRequestBody,
    ),
  );
}
